import styled from 'styled-components';

export const StyledFleet = styled.div`
  display: none;
  justify-content: center;
  flex-wrap: wrap;
  width: 600px;
  max-width: 620px;
  max-height: 265px;
  background: none;
  position: absolute;
  row-gap: 0;
`;
